document.addEventListener('DOMContentLoaded', function () {
    const tabs = document.querySelectorAll('.op-product-tabs__button');

    tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
        const target = tab.getAttribute('data-tab');
        const wrapper = tab.closest('.op-product-tabs');

        wrapper.querySelectorAll('.op-product-tabs__button').forEach(function (button) {
        button.classList.remove('is-active');
        });

        wrapper.querySelectorAll('.op-product-tabs__panel').forEach(function (panel) {
        panel.classList.remove('is-active');
        });

        tab.classList.add('is-active');
        wrapper.querySelector('#' + target).classList.add('is-active');
    });
    });
});
